import { createAction, props } from '@ngrx/store';
import { IVisorState } from 'app/visor/shared/models/mapModels';
const RESET_STORE = '[STORE] reset store';
export const resetStore = createAction(RESET_STORE);
